// extracted by mini-css-extract-plugin
module.exports = {"wrapperDateSmall":"startintervention_wrapperDateSmall_3wF4M"};